module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUCAYAAAADU1RxAAAAq0lEQVRIx2M4J6j2f6Axw6gjRh0xKB1x1dT92EBjhv8UgOfPn/+/d/40mKYEkO2IexfO/b9bXfD/Tnfd/8f15UD+efo64t+/f//vTW74H9ru8X/x6vb/uw5u+n93UjNYnK6OuDuh/X840BFzNs79v3Ln3P93+jvo6whIdFz6f7+04f/x6nIwDeLTPU3AEubdc+cpT5jqYVuPDTRmYLBY8X/A8agjRh0xGB0BAFDehaslmHHQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/py.png
// module id = 908
// module chunks = 0